import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "media-settings" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "media-settings__preview" }
const _hoisted_6 = { class: "preview__novideo" }
const _hoisted_7 = { class: "media-settings__toggles" }
const _hoisted_8 = { class: "media-settings__device-error" }
const _hoisted_9 = { class: "media-settings__device-error" }
const _hoisted_10 = { class: "media-settings__settings" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcCheckboxRadioSwitch = _resolveComponent("NcCheckboxRadioSwitch")
  const _component_NcNoteCard = _resolveComponent("NcNoteCard")
  const _component_IconReflectHorizontal = _resolveComponent("IconReflectHorizontal")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_VideoBackground = _resolveComponent("VideoBackground")
  const _component_AvatarWrapper = _resolveComponent("AvatarWrapper")
  const _component_VolumeIndicator = _resolveComponent("VolumeIndicator")
  const _component_NcIconSvgWrapper = _resolveComponent("NcIconSvgWrapper")
  const _component_NcPopover = _resolveComponent("NcPopover")
  const _component_IconVideo = _resolveComponent("IconVideo")
  const _component_IconVideoOffOutline = _resolveComponent("IconVideoOffOutline")
  const _component_MediaDevicesSelector = _resolveComponent("MediaDevicesSelector")
  const _component_MediaDevicesSpeakerTest = _resolveComponent("MediaDevicesSpeakerTest")
  const _component_VideoBackgroundEditor = _resolveComponent("VideoBackgroundEditor")
  const _component_MediaSettingsTabs = _resolveComponent("MediaSettingsTabs")
  const _component_SetGuestUsername = _resolveComponent("SetGuestUsername")
  const _component_CallButton = _resolveComponent("CallButton")

  return ($data.show)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent($props.isDialog ? 'NcModal' : 'div'), {
        key: 0,
        size: $props.isDialog ? 'large' : undefined,
        "label-id": $props.isDialog ? $setup.dialogHeaderId : undefined,
        onClose: $options.close
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            ($props.isDialog)
              ? (_openBlock(), _createElementBlock("h2", {
                  key: 0,
                  id: $setup.dialogHeaderId,
                  class: "media-settings__title nc-dialog-alike-header"
                }, _toDisplayString($options.t('spreed', 'Check devices')), 9, _hoisted_2))
              : _createCommentVNode("", true),
            ($options.showRecordingWarning)
              ? (_openBlock(), _createBlock(_component_NcNoteCard, {
                  key: 1,
                  class: _normalizeClass({ 'media-settings__recording-warning--mobile': $setup.isMobile }),
                  type: "warning"
                }, {
                  default: _withCtx(() => [
                    ($options.isCurrentlyRecording)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                          _createElementVNode("strong", null, _toDisplayString($options.t('spreed', 'The call is being recorded.')), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_4, [
                          _createElementVNode("strong", null, _toDisplayString($options.t('spreed', 'The call might be recorded.')), 1)
                        ])),
                    ($options.isRecordingConsentRequired)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("p", null, _toDisplayString($options.t('spreed', 'The recording might include your voice, video from camera, and screen share. Your consent is required before joining the call.')), 1),
                          _createVNode(_component_NcCheckboxRadioSwitch, {
                            class: "checkbox--warning",
                            "model-value": $props.recordingConsentGiven,
                            "onUpdate:modelValue": $options.setRecordingConsentGiven
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($options.t('spreed', 'Give consent to the recording of this call')), 1)
                            ]),
                            _: 1
                          }, 8, ["model-value", "onUpdate:modelValue"])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["media-settings__content", { 'media-settings__content--mobile': $setup.isMobile }])
            }, [
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("video", {
                  ref: "video",
                  class: _normalizeClass(["preview__video", { 'preview__video--mirrored': $data.isMirrored }]),
                  disablePictureInPicture: "",
                  tabindex: "-1"
                }, null, 2), [
                  [_vShow, $options.showVideo]
                ]),
                ($options.showVideo)
                  ? (_openBlock(), _createBlock(_component_NcButton, {
                      key: 0,
                      variant: "secondary",
                      class: "media-settings__preview-mirror",
                      title: $options.mirrorToggleLabel,
                      "aria-label": $options.mirrorToggleLabel,
                      onClick: _cache[0] || (_cache[0] = $event => ($data.isMirrored = !$data.isMirrored))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_IconReflectHorizontal, { size: 20 })
                      ]),
                      _: 1
                    }, 8, ["title", "aria-label"]))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_VideoBackground, {
                    "display-name": $options.displayName,
                    user: $options.userId
                  }, null, 8, ["display-name", "user"]),
                  _createVNode(_component_AvatarWrapper, {
                    id: $options.userId,
                    token: $setup.token,
                    name: $options.displayName,
                    source: $setup.actorStore.actorType,
                    size: $setup.AVATAR.SIZE.EXTRA_LARGE,
                    "disable-menu": "",
                    "disable-tooltip": ""
                  }, null, 8, ["id", "token", "name", "source", "size"])
                ], 512), [
                  [_vShow, !$options.showVideo]
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (!$setup.audioStreamError)
                    ? (_openBlock(), _createBlock(_component_NcButton, {
                        key: 0,
                        variant: "tertiary",
                        title: $options.audioButtonTitle,
                        "aria-label": $options.audioButtonTitle,
                        disabled: !$setup.audioPreviewAvailable,
                        onClick: $options.toggleAudio
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_VolumeIndicator, {
                            "audio-preview-available": $setup.audioPreviewAvailable,
                            "audio-enabled": $data.audioOn,
                            "current-volume": $setup.currentVolume,
                            "volume-threshold": $setup.currentThreshold,
                            "overlay-muted-color": "#888888"
                          }, null, 8, ["audio-preview-available", "audio-enabled", "current-volume", "volume-threshold"])
                        ]),
                        _: 1
                      }, 8, ["title", "aria-label", "disabled", "onClick"]))
                    : (_openBlock(), _createBlock(_component_NcPopover, {
                        key: 1,
                        title: $options.t('spreed', 'Show more info'),
                        "no-focus-trap": ""
                      }, {
                        trigger: _withCtx(() => [
                          _createVNode(_component_NcButton, {
                            variant: "error",
                            "aria-label": $options.t('spreed', 'Audio is not available')
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_NcIconSvgWrapper, {
                                svg: $setup.IconMicrophoneOffOutline,
                                size: 20
                              }, null, 8, ["svg"])
                            ]),
                            _: 1
                          }, 8, ["aria-label"])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_8, _toDisplayString($options.audioStreamErrorMessage), 1)
                        ]),
                        _: 1
                      }, 8, ["title"])),
                  (!$setup.videoStreamError)
                    ? (_openBlock(), _createBlock(_component_NcButton, {
                        key: 2,
                        variant: "tertiary",
                        title: $options.videoButtonTitle,
                        "aria-label": $options.videoButtonTitle,
                        disabled: !$setup.videoPreviewAvailable,
                        onClick: $options.toggleVideo
                      }, {
                        icon: _withCtx(() => [
                          ($data.videoOn)
                            ? (_openBlock(), _createBlock(_component_IconVideo, {
                                key: 0,
                                size: 20
                              }))
                            : (_openBlock(), _createBlock(_component_IconVideoOffOutline, {
                                key: 1,
                                size: 20
                              }))
                        ]),
                        _: 1
                      }, 8, ["title", "aria-label", "disabled", "onClick"]))
                    : (_openBlock(), _createBlock(_component_NcPopover, {
                        key: 3,
                        title: $options.t('spreed', 'Show more info'),
                        "no-focus-trap": ""
                      }, {
                        trigger: _withCtx(() => [
                          _createVNode(_component_NcButton, {
                            variant: "error",
                            "aria-label": $options.t('spreed', 'Video is not available')
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_IconVideoOffOutline, { size: 20 })
                            ]),
                            _: 1
                          }, 8, ["aria-label"])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_9, _toDisplayString($options.videoStreamErrorMessage), 1)
                        ]),
                        _: 1
                      }, 8, ["title"]))
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_MediaSettingsTabs, {
                  active: $data.tabContent,
                  "onUpdate:active": _cache[1] || (_cache[1] = $event => (($data.tabContent) = $event)),
                  tabs: $setup.tabs
                }, {
                  "tab-panel:devices": _withCtx(() => [
                    _createVNode(_component_MediaDevicesSelector, {
                      kind: "audioinput",
                      devices: $setup.devices,
                      "device-id": $setup.audioInputId,
                      onRefresh: $setup.updateDevices,
                      "onUpdate:deviceId": $options.handleAudioInputIdChange
                    }, null, 8, ["devices", "device-id", "onRefresh", "onUpdate:deviceId"]),
                    _createVNode(_component_MediaDevicesSelector, {
                      kind: "videoinput",
                      devices: $setup.devices,
                      "device-id": $setup.videoInputId,
                      onRefresh: $setup.updateDevices,
                      "onUpdate:deviceId": $options.handleVideoInputIdChange
                    }, null, 8, ["devices", "device-id", "onRefresh", "onUpdate:deviceId"]),
                    ($setup.audioOutputSupported)
                      ? (_openBlock(), _createBlock(_component_MediaDevicesSelector, {
                          key: 0,
                          kind: "audiooutput",
                          devices: $setup.devices,
                          "device-id": $setup.audioOutputId,
                          onRefresh: $setup.updateDevices,
                          "onUpdate:deviceId": $options.handleAudioOutputIdChange
                        }, {
                          "extra-action": _withCtx(() => [
                            _createVNode(_component_MediaDevicesSpeakerTest, { disabled: $setup.audioStreamError }, null, 8, ["disabled"])
                          ]),
                          _: 1
                        }, 8, ["devices", "device-id", "onRefresh", "onUpdate:deviceId"]))
                      : _createCommentVNode("", true)
                  ]),
                  "tab-panel:backgrounds": _withCtx(() => [
                    _createVNode(_component_VideoBackgroundEditor, {
                      class: "media-settings__tab",
                      token: $setup.token,
                      "skip-blur-virtual-background": $data.skipBlurVirtualBackground,
                      onUpdateBackground: $options.handleUpdateVirtualBackground
                    }, null, 8, ["token", "skip-blur-virtual-background", "onUpdateBackground"])
                  ]),
                  _: 1
                }, 8, ["active", "tabs"]),
                ($options.isGuest)
                  ? (_openBlock(), _createBlock(_component_SetGuestUsername, {
                      key: 0,
                      compact: "",
                      onUpdate: _cache[2] || (_cache[2] = $event => ($data.guestUserName = $event))
                    }))
                  : _createCommentVNode("", true),
                ($options.showStartRecordingOption)
                  ? (_openBlock(), _createBlock(_component_NcCheckboxRadioSwitch, {
                      key: 1,
                      modelValue: $data.isRecordingFromStart,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.isRecordingFromStart) = $event)),
                      class: "checkbox"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.t('spreed', 'Start recording immediately with the call')), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                ($options.showNotifyCallOption)
                  ? (_openBlock(), _createBlock(_component_NcCheckboxRadioSwitch, {
                      key: 2,
                      modelValue: $data.notifyCall,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = $event => (($data.notifyCall) = $event)),
                        $options.setNotifyCall
                      ],
                      class: "checkbox"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.t('spreed', 'Notify all participants about this call')), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true),
                ($options.showUpdateChangesButton)
                  ? (_openBlock(), _createBlock(_component_NcButton, {
                      key: 3,
                      class: "action-button",
                      onClick: $options.closeModalAndApplySettings
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($data.isDeviceCheck ? $options.t('spreed', 'Save') : $options.t('spreed', 'Apply settings')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : ($options.isBeforeJoinCall)
                    ? (_openBlock(), _createBlock(_component_CallButton, {
                        key: 4,
                        class: "action-button",
                        "is-media-settings": "",
                        "is-recording-from-start": $data.isRecordingFromStart,
                        disabled: $options.disabledCallButton,
                        "recording-consent-given": $props.recordingConsentGiven,
                        "silent-call": !$data.notifyCall
                      }, null, 8, ["is-recording-from-start", "disabled", "recording-consent-given", "silent-call"]))
                    : _createCommentVNode("", true)
              ])
            ], 2)
          ])
        ]),
        _: 1
      }, 40, ["size", "label-id", "onClose"]))
    : _createCommentVNode("", true)
}